// extracted by mini-css-extract-plugin
export default {"basic-panel":"AdminsTable_basic-panel__2gQ1v","disabled":"AdminsTable_disabled__n17CI"};